<template >
  <v-app  >
    <v-navigation-drawer class="navigation-custom" v-if="auth" app
        v-model="drawer"
        :mini-variant.sync="mini"
        permanent
    >
      <v-list-item v-if="this.user" class="px-2">
        <v-list-item-avatar>
          <v-img :src="baseUrl+'/'+this.user.image.path.replace('media','')" ></v-img>
        </v-list-item-avatar>

        <v-list-item-title>{{ this.user.first_name }}</v-list-item-title>

        <v-btn
            icon
            @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>


      <v-list-group
          :value="false"
          prepend-icon="mdi-chart-areaspline"
      >
        <template v-slot:activator>
          <v-list-item-title>ข้อมูลรายงาน</v-list-item-title>
        </template>

        <v-list-item
            to="/ReportProduct"
            link
        >
          <v-list-item-content>
            <v-list-item-title
            >รายงานเบิกสินค้า</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
            to="/ReportStock"
            link
        >
          <v-list-item-content>
            <v-list-item-title>รายงานสินค้าคงคลัง</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-list-item
            to="/ReportProductDetail"
            link
        >
          <v-list-item-content>
            <v-list-item-title>รายละเอียดสินค้า</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
            to="/ReportProductStock"
            link
        >
          <v-list-item-content>
            <v-list-item-title>รายละเอียดการเบิกจ่ายสินค้า</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list-group>


        <v-list-group
            :value="false"
            prepend-icon="mdi-account-circle"
        >
          <template v-slot:activator>
            <v-list-item-title>ข้อมูลผู้ใช้งาน</v-list-item-title>
          </template>


          <v-list-item
              to="/Users"
              link
          >
            <v-list-item-content>
              <v-list-item-title>ข้อมูลผู้ใช้งาน</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

      <v-list-group
          :value="false"
          prepend-icon="mdi-cogs"
      >
        <template v-slot:activator>
          <v-list-item-title>ข้อมูลเครื่อง</v-list-item-title>
        </template>

        <v-list-item
            to="/Machine"
            link
        >
          <v-list-item-content>
            <v-list-item-title
            >ข้อมูลเครื่อง</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>


      <v-list-group
          :value="false"
          prepend-icon="mdi-folder-settings"
      >
        <template v-slot:activator>
          <v-list-item-title>ข้อมูลชิ้นงาน</v-list-item-title>
        </template>

        <v-list-item
            to="/Product"
            link
        >
          <v-list-item-content>
            <v-list-item-title>ชิ้นงาน</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            to="/ProductDeactive"
            link
        >
          <v-list-item-content>
            <v-list-item-title>ชิ้นงานปิดใช้งาน</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list dense>
        <v-list-item
            link
            v-on:click="Logout()"
        >
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>ออกจากระบบ</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>
    <v-app-bar v-if="auth" class="top_bar_container" app>
      <div class="name-title" >YN ENGINEER SYSTEM</div>
      <div></div>
      <div></div>
    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer v-if="auth" class="footer_custom" app>
      <div class="footer-copy-right" align="center" >
       COPYRIGHT © 2564 YN ENGINEERING
      </div>
    </v-footer>
  </v-app>
</template>

<script>

import {baseUrl} from "./const/api";
import {jwtDecode} from "jwt-decode";
import moment from "moment";

export default {
  name: 'App',

  components: {},
  data () {
    return {
      baseUrl:baseUrl,
      auth: localStorage.getItem('user') ? true:false,
      user: JSON.parse(localStorage.getItem('user')),
      items: [
        { title: 'Home', icon: 'mdi-home-city' },
        { title: 'My Account', icon: 'mdi-account' },
        { title: 'Users', icon: 'mdi-account-group-outline' },
      ],
      mini: true,
    }
  },
  methods:{
    Logout(){
      localStorage.removeItem('user');
      localStorage.removeItem('access_token');
      window.location = "/login"
    },
    checkTokenExpiration(expirationTimestamp){
      const expirationMoment = moment.unix(expirationTimestamp);
      const currentMoment = moment();

      if (currentMoment.isAfter(expirationMoment)) {
        return { expired: true, expirationDate: expirationMoment.format() };
      } else {
        return { expired: false, expirationDate: expirationMoment.format() };
      }
    },
    CheckLogin(){
     // console.log(this.$router.currentRoute.path)
      const UserData = localStorage.getItem('user');
      const access_token = localStorage.getItem('access_token');
      if(access_token){
        const access_token_decode = jwtDecode(access_token);
        // console.warn(access_token_decode.exp);
        const  checkTokenExpiration = this.checkTokenExpiration(access_token_decode.exp)
        // console.warn(checkTokenExpiration.expired);

        if(checkTokenExpiration.expired == true && UserData){
          this.Logout();
        }
      }


      if(!UserData && this.$router.currentRoute.path !== "/login"){
       window.location = "/login"
      }else{

        //console.log("Nologin")
      }
    }

  },
  mounted() {
    this.CheckLogin()
    console.log("build 10012024")
  },
  created() {
    //console.log(process.env)
  }
};
</script>
<style>
.footer_custom{
  justify-content: center;
}
.v-toolbar__content{
  display: flex;
  height: 64px;
  width: 100%;
  justify-content: space-between;
}
</style>
